export default "__VITE_ASSET__CepGIXin__"